export class GetTradeCostsListTransactionsError extends Error {}
